import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { mergeRefs } from '../../BKJSelect/utils/mergeRefs.js';
import { BKJTextInput } from '../../BKJTextInput/index.js';
import { useRightIconProps } from '../BKJComboBoxAsync.utils.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
const variantMap = {
    Search: 'ComboBoxSeamlessRounded',
};
export const BKJComboBoxAsyncInput = forwardRef(({ autoComplete, className, css, overrides = [], ...rest }, ref) => {
    const { label, variant = 'Search', action, error, required, getComboboxProps, setAnchorElement, getInputProps, searchValue, getLabelProps, isOpen, onInputFocus, onInputKeyDown, placeholder, selectedItem, searchKey, leftIconProps, disabled, isDropdownReverse, onSearchChange, } = useBKJComboBoxAsyncContext();
    const rightIconProps = useRightIconProps(action, disabled);
    const inputProps = getInputProps({
        ...rest,
        onKeyDown: onInputKeyDown,
        value: !isOpen ? selectedItem?.label || '' : searchValue,
        onFocus: onInputFocus,
        ref,
        name: searchKey,
        onChange: onSearchChange,
        required,
        label,
        disabled,
        placeholder,
    });
    if (overrides.includes('NoInitialResults')) {
        return (_jsx(BKJTextInput, { isOpen: typeof searchValue === 'string' && searchValue === '' ? false : isOpen, labelProps: getLabelProps(), fieldSetProps: getComboboxProps(), variant: variantMap[variant], ...inputProps, className: className, css: css, rightIconProps: rightIconProps, leftIconProps: leftIconProps, error: error, autoComplete: autoComplete, ref: mergeRefs([setAnchorElement, inputProps.ref]) }));
    }
    return (_jsx(BKJTextInput, { isOpen: isOpen, labelProps: getLabelProps(), fieldSetProps: getComboboxProps(), variant: variantMap[variant], openBorderLocation: !!isDropdownReverse ? 'top' : 'bottom', ...inputProps, className: className, css: css, rightIconProps: rightIconProps, leftIconProps: leftIconProps, error: error, autoComplete: autoComplete, ref: mergeRefs([setAnchorElement, inputProps.ref]) }));
});
//# sourceMappingURL=BKJComboBoxAsyncInput.js.map